module.exports = __webpack_public_path__ + "img/look_appli_pic2.a248b620.png";